import { render, staticRenderFns } from "./RouteDetails.vue?vue&type=template&id=9bc472da&"
import script from "./RouteDetails.vue?vue&type=script&lang=js&"
export * from "./RouteDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports